import { Currency, listInMonthExpensesQuery, Note } from '@shared/services/gql.service';

export enum ExpenseSource {
  'Evidence Based' = 'Evidence Based',
  'Forecast' = 'Forecast',
  Invoice = 'Invoice',
  Manual = 'Manual',
  None = 'None',
  'Vendor Estimate' = 'Vendor Estimate',
}

export interface QuarterCloseAdjustmentGridData
  extends Omit<listInMonthExpensesQuery, '__typename' | 'total_monthly_expense'> {
  actuals_performed_to_date: number;
  actuals_to_date: number;
  canEditVendorEstimate: boolean;
  cost_category_name: string;

  current_forecast_amount: number;
  current_forecast_percentage: number;
  current_forecast_unit: number;
  evidence_based_amount: number;

  evidence_based_exist: boolean;

  evidence_based_percentage: number;

  evidence_based_unit: number;
  expense_ltd: number;

  historical_adjustment_amount: number;
  invoices_amount: number;
  invoices_amount_exist: boolean;

  invoices_available: number;
  invoices_percentage: number;
  notes: Omit<Note, 'metadata' | 'update_date' | 'updated_by'>[];
  prev_month_amount: number;
  prev_month_unit: number;

  previous_months_accruals: number;
  receives_vendor_estimate: boolean;
  tma_amount: number;

  tma_percentage: number;

  tma_source: ExpenseSource;
  tma_unit: number;
  tma_unit_cost: number;

  total_adjustment: number;

  total_amount: number;
  total_documents: number;
  total_monthly_expense: number;
  total_remaining: number;
  units: number;
  variance_to_forecast: number;
  variance_to_previous_month?: number;
  variance_to_previous_month_percentage?: null | number;
  vendor_estimate_amount: number;
  vendor_estimate_amount_ltd: number;
  vendor_estimate_percent_ltd: number;
  vendor_estimate_percentage: number;

  vendor_estimate_unit: number;

  vendorCurrency: Currency;

  vendorName: string;
}
